// Central content + assets for Atelier Divine landing page

export const CONTACT = {
  phone: "+393792908157",
  phoneDisplay: "+39 379 290 8157",
  whatsapp: "393792908157",
  emailCommerciale: "atelierdivinesrls@gmail.com",
  emailDirezione: "divinecomiso@outlook.it",
  address: "Via Ampère n°63, 97013 Comiso (RG)",
  company: "Atelier Divine s.r.l.s.",
};

export const WHATSAPP_URL = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(
  "Ciao Atelier Divine, vorrei prenotare un appuntamento per una prova in Atelier."
)}`;
export const WHATSAPP_URL_EN = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(
  "Hello Atelier Divine, I would like to book an appointment for a fitting at your Atelier."
)}`;
export const TEL_URL = `tel:${CONTACT.phone}`;

export const SOCIALS = [
  { label: "Instagram", href: "https://www.instagram.com/atelierdivinecomiso/", icon: "instagram" },
  { label: "Facebook", href: "https://www.facebook.com/atelierdivinecomiso/", icon: "facebook" },
  { label: "YouTube", href: "https://www.youtube.com/@AtelierDivinecomiso", icon: "youtube" },
  { label: "Pinterest", href: "https://it.pinterest.com/Atelierdivinecomiso/", icon: "pinterest" },
];

const q = "?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

// Real brand assets uploaded by the atelier
export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_bridal-atelier-luxe/artifacts/b8bff3ha_Contorno%20Logo%20Divine.webp",
  claudio: "https://customer-assets.emergentagent.com/job_bridal-atelier-luxe/artifacts/mbgbl1z7_Immagine%20WhatsApp%202025-02-06%20ore%2014.06.43_0c5f61f7.jpg",
  goldCarpet: "https://customer-assets.emergentagent.com/job_bridal-atelier-luxe/artifacts/3yphcr4b_Progetto%20senza%20titolo.png",
  goldJacquard: "https://customer-assets.emergentagent.com/job_bridal-atelier-luxe/artifacts/u76h602q_Gai_Mattiolo_The-Show-Collection_2025_01-scaled.webp",
  bannerSposi: "https://customer-assets.emergentagent.com/job_bridal-atelier-luxe/artifacts/b2od3ucw_Bianco%20Minimalista%20Gioielli%20e%20Accessori%20Copertina%20di%20Facebook.png",
  atelierShoot: "https://customer-assets.emergentagent.com/job_bridal-atelier-luxe/artifacts/n44y6vwp_Gemini_Generated_Image_t73iyvt73iyvt73i.webp",
  sposoTux: "https://customer-assets.emergentagent.com/job_bridal-atelier-luxe/artifacts/iw6t2i2b_gai-mattiolo-uomo-02.jpg",
  heroBride: "https://customer-assets.emergentagent.com/job_bridal-atelier-luxe/artifacts/aayxw2yg_Veni%20Fantino.png",
  sposaSteps: "https://customer-assets.emergentagent.com/job_bridal-atelier-luxe/artifacts/o6ax7rx1_456233738_1046208976893143_7881895430310000066_n.jpg",
  sposaTulle: "https://customer-assets.emergentagent.com/job_bridal-atelier-luxe/artifacts/b5j4m39n_468676912_18361377430143455_2036966694812057068_n.jpg",
  sartoriaLace: "https://customer-assets.emergentagent.com/job_bridal-atelier-luxe/artifacts/b5b3tjqm_sartoria-pizzo.atelier-divine.jpg",
  interniNegozio: "https://customer-assets.emergentagent.com/job_bridal-atelier-luxe/artifacts/08gqp0ge_interni%20negozio%2001.webp",
  dressRack: "https://customer-assets.emergentagent.com/job_bridal-atelier-luxe/artifacts/530uq86a_abiti%20appesi%2C%20veni%20fantino.jpg",
  navySuit: "https://customer-assets.emergentagent.com/job_bridal-atelier-luxe/artifacts/gfog3h2l_Gemini_Generated_Image_r1auowr1auowr1au.webp",
};

export const IMAGES = {
  hero: ASSETS.heroBride,
  sposa: ASSETS.sposaSteps,
  sposo: ASSETS.sposoTux,
  cerimonia: "https://customer-assets-gfyr7b9c.emergentagent.net/job_bridal-atelier-luxe/artifacts/w15thh9a_IMG-20240217-WA0023.jpg",
  lace: ASSETS.sartoriaLace,
  veil: "https://images.unsplash.com/photo-1521467752200-3bccf80f16ed" + q,
  outlet: ASSETS.interniNegozio,
  shoes: "https://customer-assets-gfyr7b9c.emergentagent.net/job_bridal-atelier-luxe/artifacts/fcqbebca_avalia-bridal-shoes-atrix-_3_.webp",
};

export const NAV_LINKS = [
  { label: "Atelier", en: "Atelier", href: "#manifesto" },
  { label: "Collezioni", en: "Collections", href: "#collezioni" },
  { label: "Outlet", en: "Outlet", href: "#outlet" },
  { label: "Nel Mondo", en: "Worldwide", href: "#nel-mondo" },
  { label: "Il Team", en: "The Team", href: "#team" },
  { label: "Recensioni", en: "Reviews", href: "#recensioni" },
  { label: "FAQ", en: "FAQ", href: "#faq" },
  { label: "Contatti", en: "Contact", href: "#contatti" },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "La Visione",
    titleEn: "The Vision",
    body: "Ogni sposa custodisce un sogno. Il nostro compito è dargli forma: ascoltare, interpretare e trasformare un desiderio in un abito che parli di te, del tuo giorno più prezioso.",
    bodyEn: "Every bride holds a dream. Our task is to give it shape: to listen, interpret and transform a desire into a gown that speaks of you, of your most precious day.",
  },
  {
    n: "02",
    title: "La Sartorialità",
    titleEn: "The Craftsmanship",
    body: "Tessuti selezionati, ricami eseguiti a mano, proporzioni disegnate su misura. Nel nostro Atelier ogni dettaglio è pensato per esaltare la tua unicità con discrezione ed eleganza.",
    bodyEn: "Selected fabrics, hand-made embroidery, made-to-measure proportions. In our Atelier every detail is designed to enhance your uniqueness with discretion and elegance.",
  },
  {
    n: "03",
    title: "L'Esperienza",
    titleEn: "The Experience",
    body: "Un percorso intimo e riservato, su appuntamento. Ti accompagniamo dalla prima prova fino all'ultima cucitura, con la cura e l'attenzione che un momento così merita.",
    bodyEn: "An intimate, private journey, by appointment. We accompany you from the first fitting to the very last stitch, with the care and attention such a moment deserves.",
  },
];

export const COLLECTIONS = [
  {
    tag: "Alta Moda Sposa",
    tagEn: "Bridal Haute Couture",
    title: "Abiti da Sposa",
    titleEn: "Wedding Dresses",
    text: "Silhouette senza tempo e creazioni contemporanee per la tua entrata più attesa.",
    textEn: "Timeless silhouettes and contemporary creations for your most awaited entrance.",
    image: IMAGES.sposa,
  },
  {
    tag: "Sartoria Uomo",
    tagEn: "Men's Tailoring",
    title: "Abiti da Sposo",
    titleEn: "Groom Suits",
    text: "Tailoring impeccabile per lo sposo che desidera classe e personalità.",
    textEn: "Impeccable tailoring for the groom who desires class and personality.",
    image: IMAGES.sposo,
  },
  {
    tag: "Cerimonia Uomo",
    tagEn: "Men's Ceremony",
    title: "Cerimonia Uomo",
    titleEn: "Men's Ceremony",
    text: "Completi raffinati per lo sposo, i papà degli sposi, i testimoni e gli invitati uomini.",
    textEn: "Refined suits for the groom, fathers, best men and male guests.",
    image: IMAGES.cerimonia,
  },
];

export const TEAM = [
  {
    name: "Claudio",
    role: "Direzione & Reparto Uomo",
    roleEn: "Management & Menswear",
    bio: "Il cuore organizzativo e amministrativo dell'Atelier. Si occupa del reparto uomo, offrendo consulenze personalizzate per aiutare gli sposi a scegliere l'abito perfetto, e coordina ogni aspetto dell'attività con fluidità ed efficienza.",
    bioEn: "The organisational and administrative heart of the Atelier. He runs the menswear department, offering personalised consultations to help grooms choose the perfect suit, and coordinates every aspect of the business with fluidity and efficiency.",
  },
  {
    name: "Serena",
    role: "Selezione & Design",
    roleEn: "Selection & Design",
    bio: "Con un occhio attento alle nuove tendenze e un'innata sensibilità per il design, cura la selezione degli abiti. Grazie al suo gusto raffinato, garantisce che ogni capo rispecchi l'eleganza e la qualità che ci contraddistinguono.",
    bioEn: "With a keen eye for new trends and an innate sensitivity for design, she curates the gown selection. Thanks to her refined taste, she ensures every piece reflects the elegance and quality that set us apart.",
  },
  {
    name: "Valentina",
    role: "Consulenza & Accoglienza",
    roleEn: "Consulting & Hospitality",
    bio: "La nostra preziosa aiutante, presente nel reparto maschile e femminile. Con versatilità e attenzione ai dettagli assiste i clienti nella scelta dell'abito giusto, offrendo un servizio completo e impeccabile in ogni fase del percorso.",
    bioEn: "Our precious right hand, present in both the menswear and bridal departments. With versatility and attention to detail she assists clients in choosing the right outfit, offering a complete and impeccable service at every step of the journey.",
  },
];

export const ORIGIN = { name: "Comiso", region: "Atelier", lat: 36.9469, lng: 14.6058 };

export const DESTINATIONS = [
  // Sicilia
  { name: "Ragusa", region: "Sicilia", lat: 36.925, lng: 14.7307 },
  { name: "Vittoria", region: "Sicilia", lat: 36.95, lng: 14.5333 },
  { name: "Scicli", region: "Sicilia", lat: 36.7911, lng: 14.7025 },
  { name: "Marina di Ragusa", region: "Sicilia", lat: 36.7833, lng: 14.55 },
  { name: "Gela", region: "Sicilia", lat: 37.0667, lng: 14.25 },
  { name: "Mineo", region: "Sicilia", lat: 37.2667, lng: 14.6917 },
  { name: "Grammichele", region: "Sicilia", lat: 37.2144, lng: 14.6367 },
  { name: "Mazzarrone", region: "Sicilia", lat: 37.05, lng: 14.5667 },
  { name: "Caltagirone", region: "Sicilia", lat: 37.2372, lng: 14.5117 },
  { name: "Palermo", region: "Sicilia", lat: 38.1157, lng: 13.3615 },
  { name: "Pedalino", region: "Sicilia", lat: 36.9333, lng: 14.5833 },
  { name: "Niscemi", region: "Sicilia", lat: 37.15, lng: 14.3833 },
  { name: "Catania", region: "Sicilia", lat: 37.5079, lng: 15.083 },
  { name: "Messina", region: "Sicilia", lat: 38.1938, lng: 15.554 },
  { name: "Chiaramonte Gulfi", region: "Sicilia", lat: 37.0333, lng: 14.7 },
  { name: "Monterosso Almo", region: "Sicilia", lat: 37.0894, lng: 14.7642 },
  { name: "Vizzini", region: "Sicilia", lat: 37.1614, lng: 14.755 },
  { name: "Francofonte", region: "Sicilia", lat: 37.2286, lng: 14.8783 },
  // Italia
  { name: "Reggio Calabria", region: "Italia", lat: 38.1105, lng: 15.6613 },
  { name: "Napoli", region: "Italia", lat: 40.8518, lng: 14.2681 },
  { name: "Roma", region: "Italia", lat: 41.9028, lng: 12.4964 },
  // Nel Mondo
  { name: "Malta", region: "Nel Mondo", lat: 35.8989, lng: 14.5146 },
  { name: "Germania", region: "Nel Mondo", lat: 52.52, lng: 13.405 },
  { name: "Canada", region: "Nel Mondo", lat: 43.6532, lng: -79.3832 },
  { name: "Australia", region: "Nel Mondo", lat: -33.8688, lng: 151.2093 },
  { name: "Stati Uniti", region: "Nel Mondo", lat: 40.7128, lng: -74.006 },
  { name: "Romania", region: "Nel Mondo", lat: 44.4268, lng: 26.1025 },
  { name: "Danimarca", region: "Nel Mondo", lat: 55.6761, lng: 12.5683 },
  { name: "Spagna", region: "Nel Mondo", lat: 40.4168, lng: -3.7038 },
  { name: "India", region: "Nel Mondo", lat: 28.6139, lng: 77.209 },
];

// Countries shown in the side panel (cities stay only on the globe)
export const COUNTRIES = [
  { name: "Italia", nameEn: "Italy", group: "Italia", lat: 39.5, lng: 14.5, altitude: 1.1 },
  { name: "Malta", nameEn: "Malta", group: "Nel Mondo", lat: 35.8989, lng: 14.5146, altitude: 0.9 },
  { name: "Spagna", nameEn: "Spain", group: "Nel Mondo", lat: 40.4168, lng: -3.7038, altitude: 1.3 },
  { name: "Germania", nameEn: "Germany", group: "Nel Mondo", lat: 52.52, lng: 13.405, altitude: 1.3 },
  { name: "Danimarca", nameEn: "Denmark", group: "Nel Mondo", lat: 55.6761, lng: 12.5683, altitude: 1.3 },
  { name: "Romania", nameEn: "Romania", group: "Nel Mondo", lat: 44.4268, lng: 26.1025, altitude: 1.3 },
  { name: "Stati Uniti", nameEn: "United States", group: "Nel Mondo", lat: 40.7128, lng: -74.006, altitude: 1.8 },
  { name: "Canada", nameEn: "Canada", group: "Nel Mondo", lat: 43.6532, lng: -79.3832, altitude: 1.8 },
  { name: "India", nameEn: "India", group: "Nel Mondo", lat: 28.6139, lng: 77.209, altitude: 1.8 },
  { name: "Australia", nameEn: "Australia", group: "Nel Mondo", lat: -33.8688, lng: 151.2093, altitude: 1.8 },
];

export const FAQS = [
  {
    q: "Quanto tempo prima è consigliabile prenotare la prima prova d'abito?",
    qEn: "How far in advance should I book my first dress fitting?",
    a: "Per la sposa consigliamo di iniziare la ricerca tra i 6 e i 9 mesi prima delle nozze; per lo sposo e la cerimonia uomo tra i 3 e i 5 mesi prima. Questo permette al nostro laboratorio sartoriale interno di curare ogni personalizzazione su misura con la massima calma ed eccellenza.",
    aEn: "For the bride we recommend starting the search 6 to 9 months before the wedding; for the groom and men's ceremony wear, 3 to 5 months before. This allows our in-house tailoring workshop to take care of every made-to-measure customisation with the utmost calm and excellence.",
  },
  {
    q: "L'appuntamento in Atelier è gratuito e privato?",
    qEn: "Is the appointment at the Atelier free and private?",
    a: "Sì, la prova d'abito da Atelier Divine è totalmente gratuita e riservata. Dedichiamo lo showroom in esclusiva a te e ai tuoi accompagnatori per farti vivere un'esperienza intima, senza fretta e con la massima riservatezza.",
    aEn: "Yes, the dress fitting at Atelier Divine is completely free and private. We dedicate the showroom exclusively to you and your guests, for an intimate, unhurried experience with the utmost privacy.",
  },
  {
    q: "Eseguite modifiche e personalizzazioni sartoriali sugli abiti?",
    qEn: "Do you carry out tailoring alterations and customisations?",
    a: "Assolutamente sì. Ogni abito da sposa, sposo o cerimonia uomo viene adattato e rifinito dalla nostra sartoria interna. Possiamo personalizzare dettagli, scollature, tessuti e vestibilità per creare un capo unico e perfetto per la tua fisicità.",
    aEn: "Absolutely. Every wedding dress, groom suit or men's ceremony outfit is adjusted and finished by our in-house tailoring team. We can customise details, necklines, fabrics and fit to create a unique garment, perfect for your body shape.",
  },
  {
    q: "Offrite il servizio di noleggio o una sezione Outlet?",
    qEn: "Do you offer a rental service or an Outlet area?",
    a: "Sì. In Atelier disponiamo sia di un servizio di noleggio per abiti da cerimonia uomo, sia di un'area Outlet riservata con creazioni esclusive a condizioni vantaggiose. Entrambe le opzioni sono visionabili e provabili esclusivamente dal vivo in negozio su appuntamento.",
    aEn: "Yes. The Atelier offers both a rental service for men's ceremony wear and a reserved Outlet area with exclusive creations at advantageous prices. Both options can only be viewed and tried on in person, in store, by appointment.",
  },
  {
    q: "È possibile completare il look con scarpe e accessori?",
    qEn: "Can I complete my look with shoes and accessories?",
    a: "Certamente. Oltre agli abiti, in Atelier troverai una raffinata selezione di scarpe da sposa e sposo, veli preziosi, intimo e accessori sartoriali coordinati per definire ogni dettaglio del tuo stile.",
    aEn: "Certainly. Beyond the dresses, the Atelier offers a refined selection of bridal and groom shoes, precious veils, lingerie and coordinated sartorial accessories to define every detail of your style.",
  },
  {
    q: "Dove si trova l'Atelier e come posso prenotare?",
    qEn: "Where is the Atelier located and how can I book?",
    a: "Ci troviamo a Comiso (RG) in Via Andrè M. Ampere n° 63, con comodo parcheggio gratuito nelle immediate vicinanze. Puoi prenotare il tuo appuntamento riservato cliccando sul pulsante WhatsApp o chiamandoci direttamente al +39 379 290 8157.",
    aEn: "We are in Comiso (RG), Via Andrè M. Ampere n° 63, with convenient free parking nearby. You can book your private appointment by clicking the WhatsApp button or calling us directly at +39 379 290 8157.",
  },
];

export const REVIEWS = [
  {
    name: "Eliana Nigita",
    text: "Ci avete guidato nella scelta degli abiti con gentilezza, passione e una straordinaria capacità di ascolto. Non abbiamo trovato soltanto splendidi abiti, ma persone meravigliose.",
    textEn: "You guided us in choosing our outfits with kindness, passion and an extraordinary ability to listen. We didn't just find beautiful gowns, we found wonderful people.",
  },
  {
    name: "Tietta",
    text: "Abiti splendidi, eleganti, di classe, mai volgari o fuori luogo: ce n'è per ogni gusto e ogni necessità. Lo consiglio a tutte le future spose e anche ai futuri sposi!",
    textEn: "Splendid, elegant, classy gowns, never vulgar or out of place: there is something for every taste and need. I recommend it to all brides-to-be and grooms too!",
  },
  {
    name: "Chiara Chinnici",
    text: "Fin dal primo momento mi sono sentita accolta, ascoltata e a mio agio. Ogni prova vissuta con serenità, senza pressioni, nel pieno rispetto dei miei gusti e delle mie emozioni.",
    textEn: "From the very first moment I felt welcomed, listened to and at ease. Every fitting was serene, with no pressure, in full respect of my taste and my emotions.",
  },
  {
    name: "Silvia Lazzari",
    text: "Dal primo appuntamento hanno capito cosa desiderassi e hanno materializzato il mio sogno. Il mio abito mi ha fatta sentire una principessa, comoda ed elegante.",
    textEn: "From the first appointment they understood what I wanted and made my dream come true. My gown made me feel like a princess, comfortable and elegant.",
  },
  {
    name: "Matteo Petralia",
    text: "Entrare da Divine è vivere un'esperienza fatta di emozione, ascolto e vera bellezza. Ogni prova un momento prezioso, ogni consiglio la conferma di essere nel posto giusto.",
    textEn: "Walking into Divine means living an experience made of emotion, listening and true beauty. Every fitting is a precious moment, every piece of advice confirms you are in the right place.",
  },
  {
    name: "Giancarlo Biazzo",
    text: "Ho trovato il mio abito perfetto: elegante e raffinato. Qualità dei tessuti eccellente e le sarte hanno lavorato con grande attenzione. Consigliatissimo!",
    textEn: "I found my perfect suit: elegant and refined. Excellent fabric quality and the seamstresses worked with great care. Highly recommended!",
  },
  {
    name: "Greta Lo Monaco",
    text: "La scelta dell'abito è un momento emozionante e la loro professionalità scalfisce ogni ansia. Disponibili, puntuali, accoglienti. Gli abiti sono semplicemente superlativi.",
    textEn: "Choosing your gown is an emotional moment and their professionalism melts away any anxiety. Helpful, punctual, welcoming. The gowns are simply superb.",
  },
  {
    name: "Roberta Sciacca",
    text: "Un Atelier fatto di persone competenti e professionali. Ampia scelta di abiti, uno più meraviglioso dell'altro. Gentilezza, disponibilità e classe.",
    textEn: "An Atelier made of competent and professional people. A wide selection of gowns, each more wonderful than the last. Kindness, helpfulness and class.",
  },
  {
    name: "Mariangela Lo Cicero",
    text: "Sposa, sposo, fratello e padre della sposa: tutti vestiti da loro. Ho adorato la loro sincerità, ti consigliano con schiettezza senza mai forzare una vendita.",
    textEn: "Bride, groom, brother and father of the bride: all dressed by them. I loved their honesty, they advise you frankly without ever pushing a sale.",
  },
  {
    name: "Viviana La Gona",
    text: "Ogni particolare è studiato e arredato con gusto. Abiti molto belli sia sposa che sposo. In poche parole: professionalità, eleganza e gentilezza.",
    textEn: "Every detail is thoughtfully designed and tastefully furnished. Beautiful gowns for both bride and groom. In a few words: professionalism, elegance and kindness.",
  },
];
